import Slides from './Slides.js';

import img1 from './images/portfolio/weddings-and-engagements/6/_IMG2476.jpg';
import img2 from './images/portfolio/weddings-and-engagements/6/_IMG2924.jpg';
import img3 from './images/portfolio/weddings-and-engagements/6/_IMG3869.jpg';
import img4 from './images/portfolio/weddings-and-engagements/6/_IMG4140.jpg';
import img5 from './images/portfolio/weddings-and-engagements/6/_IMG4309-274.jpg';
import img6 from './images/portfolio/weddings-and-engagements/6/_IMG4372-322.jpg';
import img7 from './images/portfolio/weddings-and-engagements/6/_IMG4854.jpg';
import img8 from './images/portfolio/weddings-and-engagements/6/_IMG4863.jpg';
import img9 from './images/portfolio/weddings-and-engagements/6/_IMG5549-Edit.jpg';
import img10 from './images/portfolio/weddings-and-engagements/6/_IMG7359.jpg';
import img11 from './images/portfolio/weddings-and-engagements/6/_IMG7502.jpg';
import img12 from './images/portfolio/weddings-and-engagements/6/_IMG7734.jpg';
import img13 from './images/portfolio/weddings-and-engagements/6/aggimage_10091.jpg';
import img14 from './images/portfolio/weddings-and-engagements/6/aggimage_8937.jpg';
import img15 from './images/portfolio/weddings-and-engagements/6/engagement.jpg';
import img16 from './images/portfolio/weddings-and-engagements/6/img_438.jpg';
import img17 from './images/portfolio/weddings-and-engagements/6/img_504.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
];

function Architectural() {
    return <Slides images={images}/>;
}

export default Architectural;
